import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fc997eae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-box" }
const _hoisted_2 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_time_select = _resolveComponent("el-time-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mixType === 2)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: _ctx.compData.target,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.compData.target) = $event)),
          disabled: !_ctx.mainSwitch,
          class: "cm-ui-mr10",
          size: "small"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WeekDayOptions, (modelValue) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: modelValue.value,
                label: modelValue.label,
                value: modelValue.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true),
    (_ctx.mixType === 3)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          modelValue: _ctx.compData.target,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.compData.target) = $event)),
          disabled: !_ctx.mainSwitch,
          class: "cm-ui-mr10",
          size: "small"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (n) => {
              return _createVNode(_component_el_option, {
                key: n,
                label: n<10 ? `0${n}` : n,
                value: n
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_time_select, {
      modelValue: _ctx.compData.start_min,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.compData.start_min) = $event)),
      placeholder: _ctx.$t('common.phTimeStart'),
      size: "small",
      start: "00:00",
      step: "00:10",
      end: "23:59",
      editable: false,
      clearable: false,
      disabled: !_ctx.mainSwitch,
      onChange: _ctx.updateStartTime
    }, null, 8, ["modelValue", "placeholder", "disabled", "onChange"]),
    (_ctx.isRange)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " - "))
      : _createCommentVNode("", true),
    (_ctx.isRange)
      ? (_openBlock(), _createBlock(_component_el_time_select, {
          key: 3,
          modelValue: _ctx.compData.end_min,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.compData.end_min) = $event)),
          placeholder: _ctx.$t('common.phTimeEnd'),
          size: "small",
          start: "00:00",
          step: "00:10",
          end: "23:59",
          editable: false,
          clearable: false,
          "min-time": _ctx.compData.start_min,
          disabled: !_ctx.mainSwitch
        }, null, 8, ["modelValue", "placeholder", "min-time", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}